import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { NumberInput } from '@/modules/common/components/inputs';

import { useFlowUpdaters } from '../hooks/useFlowUpdaters';

type Props = {
  id: string;
  totalNumLoads: number;
  disabled: boolean;
};

function LoadPerHourInputComponent({ id, totalNumLoads, disabled }: Props) {
  const { t } = useTranslation();
  const { onFlowLoadsChange } = useFlowUpdaters(id);

  return (
    <NumberInput
      value={totalNumLoads}
      disabled={disabled}
      onChange={onFlowLoadsChange}
      ariaLabel={t('interface:properties.flows.flow_info.total_loads.label')}
      errorType='floating'
      decimals={0}
      minValue={1}
      minValueErrorMsg={t('common:minimum_value', { minValue: 1 })}
    />
  );
}

export const LoadPerHourInput = memo(LoadPerHourInputComponent);
